module.exports = __webpack_public_path__ + "img/sixpackcarrier44.1e8bded8.jpg";